// src/services/twitter.js

import apiClient from './apiClient';
import { endpoints } from '../config/apiConfig';

export const twitterService = {
  getUserIdByUsername: async (username) => {
    try {
      if (!username) {
        throw new Error('Username is required');
      }

      const cleanUsername = username
        .trim()
        .replace(/^@/, '')
        .replace(/[^A-Za-z0-9_]/g, '');

      console.log('Fetching Twitter ID for username:', cleanUsername);
      
      try {
        const response = await apiClient.get(`/twitter/user/${cleanUsername}`);
        console.log('Twitter API response:', response);

        const userData = response.data;
        
        if (!userData?.id) {
          console.error('Invalid Twitter API response:', userData);
          throw new Error('Invalid response from Twitter API');
        }

        return {
          id: userData.id,
          username: userData.username,
          followers: userData.followers || 0,
          profile_image_url: userData.profile_image_url
        };
      } catch (apiError) {
        // If the error is about endpoint not being accessible, try direct API call
        if (apiError.message?.includes('API endpoint not accessible')) {
          console.log('Trying direct API call for user data');
          const directResponse = await apiClient.get(`/twitter/user/${cleanUsername}`);
          
          const userData = directResponse.data;
          if (!userData?.id) {
            throw new Error('Invalid response from Twitter API');
          }
          
          return {
            id: userData.id,
            username: userData.username,
            followers: userData.followers || 0,
            profile_image_url: userData.profile_image_url
          };
        }
        throw apiError;
      }
    } catch (error) {
      console.error('Error in getUserIdByUsername:', {
        error: error,
        message: error.message,
        stack: error.stack
      });
      
      // Handle specific error cases
      if (error.response?.status === 404) {
        throw new Error('Twitter user not found');
      }
      
      if (error.response?.status === 429) {
        throw new Error('Twitter API rate limit exceeded. Please try again later.');
      }
      
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch Twitter user data');
    }
  },

  getFollowersByUserId: async (userId) => {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      try {
        const response = await apiClient.get(`/twitter/followers/${userId}`);
        console.log('Followers response:', response);
        
        if (!response.data?.followerCount && response.data?.followerCount !== 0) {
          throw new Error('Invalid response from Twitter API');
        }

        return response.data;
      } catch (apiError) {
        // If the error is about endpoint not being accessible, try direct API call
        if (apiError.message?.includes('API endpoint not accessible')) {
          console.log('Trying direct API call for followers');
          const directResponse = await apiClient.get(`/twitter/followers/${userId}`);
          
          if (!directResponse.data?.followerCount && directResponse.data?.followerCount !== 0) {
            throw new Error('Invalid response from Twitter API');
          }
          
          return directResponse.data;
        }
        throw apiError;
      }
    } catch (error) {
      console.error('Error in getFollowersByUserId:', {
        error: error,
        message: error.message,
        stack: error.stack
      });
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch Twitter followers data');
    }
  }
};